export default "__VITE_ASSET__Cg6h1Jtu__"